import { useState } from 'react';

const TESTIMONIALS = [
  {
    quote: '集客から営業までワンストップで支援いただき、問い合わせ数が導入前の3倍以上に増加しました。特に営業トークスクリプトの改善により成約率も大幅に向上し、安定した収益基盤が構築できています。',
    company: 'サービス業（東京都）',
    role: '代表取締役',
    industry: 'サービス業',
  },
  {
    quote: '広告を出しても成果が出なかった時期が続いていましたが、Y・F・Sさんに依頼してから集客の仕組みが整い、今では月に安定して新規顧客が獲得できています。データに基づく改善提案が非常に的確です。',
    company: 'IT・Web関連（大阪府）',
    role: '事業責任者',
    industry: 'IT・Web関連',
  },
  {
    quote: '営業が属人化していて成果にばらつきがあったのが最大の課題でした。営業フローの標準化と研修により、チーム全体の成約率が改善。今では新人でも一定の成果が出せる体制が整いました。',
    company: '建設業（神奈川県）',
    role: '営業部長',
    industry: '建設業',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS.length);
  const t = TESTIMONIALS[current];

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Image side */}
          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden aspect-[3/4]">
              <img
                src="https://y-f-s.jp/img/main2.jpeg"
                alt="お客様の声"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content side */}
          <div className="lg:col-span-3">
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Testimonials</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mt-3 mb-10">
              導入企業様の声
            </h2>

            <div className="relative">
              <i className="ri-double-quotes-l text-6xl text-[#1a2332]/10 absolute -top-4 -left-2" />
              <blockquote className="relative z-10">
                <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-8">
                  {t.quote}
                </p>
                <footer>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1a2332] text-white text-sm font-bold">
                      {t.industry[0]}
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-[#1a2332]">{t.role}</div>
                      <div className="text-xs text-gray-500">{t.company}</div>
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div>

            {/* Navigation */}
            <div className="flex items-center gap-4 mt-10">
              <button
                onClick={prev}
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-200 text-gray-600 hover:border-[#1a2332] hover:text-[#1a2332] transition-colors cursor-pointer"
                aria-label="前へ"
              >
                <i className="ri-arrow-left-line" />
              </button>
              <div className="flex gap-2">
                {TESTIMONIALS.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`transition-all duration-200 rounded-full cursor-pointer ${
                      i === current ? 'w-8 h-2 bg-[#1a2332]' : 'w-2 h-2 bg-gray-200'
                    }`}
                    aria-label={`${i + 1}番目`}
                  />
                ))}
              </div>
              <button
                onClick={next}
                className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1a2332] text-white hover:bg-[#2d3748] transition-colors cursor-pointer"
                aria-label="次へ"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
